/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import * as API from '../utils/api';
import Types from '../constants/actionTypes';
import Store from '../store/store';
import { applicationError } from './notificationActions';

const currentDeploymentId = () => Store.getState().deploymentReducer.current.id;

export const getDeployment = id => dispatch => {
  dispatch({ type: Types.REQUEST_DEPLOYMENT });
  return API.get(`deployments/${id}`)
    .then(response => {
      dispatch({
        type: Types.SET_DEPLOYMENT,
        deployment: response.deployment.id
      });
    })
    .catch(error => dispatch(applicationError(error)));
};

export const setDeployment = id => dispatch =>
  dispatch({
    type: Types.SET_DEPLOYMENT,
    deployment: id
  });

export const getAllDeployments = () => dispatch => {
  dispatch({ type: Types.REQUEST_DEPLOYMENT });
  return API.get('deployments')
    .then(response =>
      dispatch({
        type: Types.RECEIVE_DEPLOYMENTS,
        deployments: response.deployments
      })
    )
    .catch(error => {
      dispatch(applicationError(error));
      dispatch({ type: Types.REQUEST_DEPLOYMENT_FAILED });
    });
};

export const createDeployment = data => dispatch => {
  dispatch({ type: Types.SEND_DEPLOYMENT });
  return API.post('deployments', data)
    .then(() => dispatch(getAllDeployments()))
    .catch(error => dispatch(applicationError(error)));
};

export function addResultToDeployment(resultId, deploymentId) {
  const payload = { result_id: resultId };
  return dispatch => {
    dispatch({ type: Types.SEND_DEPLOYMENT });
    return API.put(
      `deployments/${deploymentId || currentDeploymentId()}/add-result`,
      payload
    )
      .then(response => response.json())
      .then(response => {
        const workPackage = response.work_package;

        dispatch({
          type: Types.UPDATE_WORK_PACKAGE,
          workPackage
        });
        dispatch({
          type: Types.ADD_WORK_PACKAGE_TO_DEPLOYMENT,
          workPackage,
          deploymentId
        });
      })
      .catch(error => dispatch(applicationError(error)));
  };
}

export function removeResultFromDeployment(resultId, deploymentId) {
  const payload = { result_id: resultId };
  return dispatch => {
    dispatch({ type: Types.SEND_DEPLOYMENT });
    return API.put(
      `deployments/${deploymentId || currentDeploymentId()}/remove-result`,
      payload
    )
      .then(response => response.json())
      .then(response => {
        const workPackage = response.work_package;

        dispatch({
          type: Types.UPDATE_WORK_PACKAGE,
          workPackage
        });
        dispatch({
          type: Types.REMOVE_WORK_PACKAGE_FROM_DEPLOYMENT,
          workPackage,
          deploymentId
        });
      })
      .catch(error => dispatch(applicationError(error)));
  };
}

export const updateDeployment = (id, data) => dispatch => {
  dispatch({ type: Types.SEND_DEPLOYMENT });
  return API.put(`deployments/${id}`, data)
    .then(() => dispatch(getAllDeployments()))
    .catch(error => dispatch(applicationError(error)));
};

export const deleteDeployment = id => dispatch => {
  dispatch({ type: Types.SEND_DEPLOYMENT });
  return API.del(`deployments/${id}`)
    .then(() => dispatch(getAllDeployments()))
    .catch(error => dispatch(applicationError(error)));
};

export const restoreDeployment = id => dispatch => {
  dispatch({ type: Types.SEND_DEPLOYMENT });
  return API.put(`deployments/${id}/restore`)
    .then(() => dispatch(getAllDeployments()))
    .catch(error => dispatch(applicationError(error)));
};
